// import React, { useState, useCallback, useMemo } from 'react';
// import { Button, Card, Form, Modal } from 'react-bootstrap';
// import { MdTouchApp } from 'react-icons/md';
// import "./compareTarget.scss";

// interface Environment {
//   environment_id: number;
//   environment_type: string;
//   customer_environment_name: string;
//   is_master: boolean
// }

// interface CompareTargetProps {
//   loading:boolean;
//   targets: Environment[];
//   setSelectedTargets: (target: string) => void;
//   resetAllStates : ()=>void
// }

// const CompareTarget: React.FC<CompareTargetProps> = ({ targets, setSelectedTargets, resetAllStates, loading }) => {
//   const [selectedItem, setSelectedItem] = useState<Environment | null>(null);
//   const [showModal, setShowModal] = useState<boolean>(false);

//   const handleSelect = useCallback((item: Environment) => {
//     setSelectedItem(item);
//   }, []);

//   function forceSetSelectedTargets(envType: string) {
//     setSelectedTargets("");
//     setTimeout(() => {
//       setSelectedTargets(envType);
//     }, 0);
//   }

//   // const handleSubmit = useCallback(() => {
//   //   // resetAllStates()

//   //   if (selectedItem && !selectedItem.is_master) {
//   //     setSelectedTargets(selectedItem.environment_type);
//   //   }
//   //   setShowModal(false);
//   // }, [selectedItem, setSelectedTargets]);

//   const handleSubmit = useCallback(() => {
//     if (selectedItem && !selectedItem.is_master) {
//       forceSetSelectedTargets(selectedItem.environment_type);
//     }
//     setShowModal(false);
//   }, [selectedItem]);

//   const handleShow = useCallback(() => setShowModal(true), []);
//   const handleClose = useCallback(() => setShowModal(false), []);

//   const nonDevTargets = useMemo(() => 
//     targets.filter((item) => {
//       return(
//         !item.is_master
//       )
//     }),
//   [targets]);
  
//   const isSingleTarget = nonDevTargets.length === 1;
//   // const shouldCenterTargets = useMemo(() => 
//   //   targets.length === 2 && targets.some(item => item.environment_type === "DEV"),
//   // [targets]);

//   return (
//     <>
//       <Button
//         variant="primary"
//         onClick={handleShow}
//         className="target-button"
//       >
//         <span>Compare Deployment Target</span>
//         <MdTouchApp size={20} />
//       </Button>

//       <Modal
//         show={showModal}
//         onHide={handleClose}
//         centered
//         contentClassName="custom-modal-content"
//       >
//         <Modal.Header>
//           <Modal.Title className="modal-title">
//             Select Deployment Target
//           </Modal.Title>
//         </Modal.Header>
        
//         <Modal.Body>
//           <div 
//             // className={`target-container ${shouldCenterTargets ? 'centered' : ''}`}
//           >
//             {nonDevTargets.map((item: Environment) => (
//               <div 
//                 key={item.environment_id} 
//                 className={`target-wrapper ${isSingleTarget ? 'single' : ''}`}
//               >
//                 <Card className="target-card">
//                   <Form.Check
//                     type="radio"
//                     id={`item-${item.environment_id}`}
//                     name="dropdown-item"
//                     label={item.customer_environment_name}
//                     checked={selectedItem?.environment_id === item.environment_id}
//                     onChange={() => handleSelect(item)}
//                     className="target-radio"
//                   />
//                 </Card>
//               </div>
//             ))}
//           </div>
//         </Modal.Body>
        
//         <Modal.Footer>
//           <Button 
//             onClick={handleSubmit} 
//             variant="success" 
//             disabled={!selectedItem} 
//             className="submit-button"
//           >
//             Submit
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </>
//   );
// };

// export default CompareTarget;

import React, { useState, useCallback, useMemo } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { MdTouchApp } from 'react-icons/md';
import { FaCheckCircle, FaDatabase, FaServer } from 'react-icons/fa';
import './compareTarget.scss';

interface Environment {
  environment_id: number;
  environment_type: string;
  customer_environment_name: string;
  is_master: boolean;
}

interface CompareTargetProps {
  loading: boolean;
  targets: Environment[];
  setSelectedTargets: (target: string) => void;
  resetAllStates: () => void;
}

const CompareTarget: React.FC<CompareTargetProps> = ({
  targets,
  setSelectedTargets,
  resetAllStates,
  loading,
}) => {
  const [selectedItem, setSelectedItem] = useState<Environment | null>(null);
  const [showModal, setShowModal] = useState<boolean>(false);

  const nonDevTargets = useMemo(
    () => targets.filter((item) => !item.is_master),
    [targets]
  );

  const handleSelect = useCallback((item: Environment) => {
    setSelectedItem(item);
  }, []);

  const forceSetSelectedTargets = useCallback(
    (envType: string) => {
      setSelectedTargets('');
      setTimeout(() => {
        setSelectedTargets(envType);
      }, 0);
    },
    [setSelectedTargets]
  );

  const handleSubmit = useCallback(() => {
    if (!selectedItem || selectedItem.is_master) return;

    resetAllStates();
    forceSetSelectedTargets(selectedItem.environment_type);
    setShowModal(false);
  }, [selectedItem, resetAllStates, forceSetSelectedTargets]);

  const handleShow = useCallback(() => {
    if (!loading) {
      setShowModal(true);
    }
  }, [loading]);

  const handleClose = useCallback(() => {
    setShowModal(false);
  }, []);

  return (
    <>
      <Button
        variant="primary"
        onClick={handleShow}
        disabled={loading}
        className="target-button"
      >
        <span className="target-button__icon">
          <MdTouchApp />
        </span>
        <span className="target-button__label">
          {loading ? 'Comparing Target...' : 'Compare Deployment Target'}
        </span>
      </Button>

      <Modal
        show={showModal}
        onHide={handleClose}
        centered
        dialogClassName="compare-target-modal"
        contentClassName="compare-target-modal__content"
        backdropClassName="compare-target-modal__backdrop"
      >
        <Modal.Header closeButton className="compare-target-modal__header">
          <div className="compare-target-modal__titleBlock">
            <span className="compare-target-modal__titleIcon">
              <FaDatabase />
            </span>

            <div>
              <Modal.Title className="compare-target-modal__title">
                Select Deployment Target
              </Modal.Title>
              <p className="compare-target-modal__subtitle">
                Choose the environment to compare against the current package.
              </p>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body className="compare-target-modal__body">
          {nonDevTargets.length > 0 ? (
            <div className="target-container">
              {nonDevTargets.map((item: Environment) => {
                const isSelected =
                  selectedItem?.environment_id === item.environment_id;

                return (
                  <button
                    type="button"
                    key={item.environment_id}
                    className={`target-card ${isSelected ? 'target-card--selected' : ''}`}
                    onClick={() => handleSelect(item)}
                  >
                    <span className="target-card__radioWrap">
                      <Form.Check
                        type="radio"
                        id={`target-${item.environment_id}`}
                        name="deployment-target"
                        checked={isSelected}
                        onChange={() => handleSelect(item)}
                        className="target-radio"
                        aria-label={item.customer_environment_name}
                      />
                    </span>

                    <span className="target-card__icon">
                      <FaServer />
                    </span>

                    <span className="target-card__content">
                      <span className="target-card__name">
                        {item.customer_environment_name}
                      </span>
                      <span className="target-card__type">
                        {item.environment_type}
                      </span>
                    </span>

                    {isSelected && (
                      <span className="target-card__selectedIcon">
                        <FaCheckCircle />
                      </span>
                    )}
                  </button>
                );
              })}
            </div>
          ) : (
            <div className="target-empty-state">
              <span className="target-empty-state__icon">
                <FaDatabase />
              </span>
              <strong>No target environments found</strong>
              <span>Please add a deployment target before comparing.</span>
            </div>
          )}
        </Modal.Body>

        <Modal.Footer className="compare-target-modal__footer">
          <Button
            variant="light"
            onClick={handleClose}
            className="target-cancel-button"
          >
            Cancel
          </Button>

          <Button
            onClick={handleSubmit}
            disabled={!selectedItem}
            className="submit-button"
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CompareTarget;